/**
 * TW Bulk Discount Messaging
 * 1 item  → upsell nudge to add 1 more for 60% off
 * 2+ items → show 60% off unlocked with fluff MRP and payable amount
 */

(function () {

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function renderMessage(cart) {
    const targets = [
      document.getElementById('tw-bulk-msg-drawer'),
      document.getElementById('tw-bulk-msg-cart')
    ].filter(Boolean);

    if (!targets.length) return;

    const totalQty = cart.item_count;

    // Fluff MRP = selling price * 2 * quantity for each line item
    const fluffMRPCents = cart.items.reduce((sum, item) => {
      return sum + (item.price * 2 * item.quantity);
    }, 0);

    let html = '';

    if (totalQty >= 2) {
      // 60% off = pay 40% of fluff MRP
      const payableCents = Math.round(fluffMRPCents * 0.40);
      const savedCents   = fluffMRPCents - payableCents;

      html = `
        <div class="tw-bulk-block tw-bulk-block--active">
          <div class="tw-bulk-badge">🔥 60% OFF Unlocked!</div>
          <div class="tw-bulk-row">
            <span class="tw-bulk-label">Total MRP</span>
            <span class="tw-bulk-mrp">${formatMoney(fluffMRPCents)}</span>
          </div>
          <div class="tw-bulk-row">
            <span class="tw-bulk-label">You Pay</span>
            <span class="tw-bulk-pay">${formatMoney(payableCents)}</span>
          </div>
          <div class="tw-bulk-saving">💰 You save ${formatMoney(savedCents)} on this order!</div>
        </div>
      `;
    } else if (totalQty === 1) {
      const twoItemPayable = formatMoney(fluffMRPCents * 2 * 0.40);
      html = `
        <div class="tw-bulk-block tw-bulk-block--nudge">
          <div class="tw-bulk-badge tw-bulk-badge--blue">💡 Add 1 more → Unlock 60% OFF</div>
          <div class="tw-bulk-nudge-text">
            Buy any 2 items and pay only <strong>40% of MRP</strong> (${twoItemPayable} for 2 tees)
          </div>
        </div>
      `;
    }

    targets.forEach(el => { el.innerHTML = html; });
  }

  function fetchAndRender() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => renderMessage(cart))
      .catch(err => console.warn('[TW Bulk Discount] cart fetch error', err));
  }

  // On page load
  document.addEventListener('DOMContentLoaded', fetchAndRender);

  // Native cart updated event
  document.addEventListener('cart:updated', fetchAndRender);

  // Minimog PubSub — cart update + drawer open
  document.addEventListener('DOMContentLoaded', function () {
    if (window.MinimogEvents && window.MinimogTheme) {

      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, function () {
        setTimeout(fetchAndRender, 200);
      });

      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, function () {
        setTimeout(fetchAndRender, 100);
      });

    }
  });

})();